import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { LogOut, Menu, X } from 'lucide-react';
import { NRLogo } from './NRLogo';
import { UserAuth } from './AuthContext';
import LogoutButton from './LogOut';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom'; // or usePathname() in Next.js

export const HeaderPost = () => {
    const location = useLocation(); 
    // console.log(location.pathname,'im here mate')

  const { session, getUser } = UserAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
const isLandingPage = window.location.pathname === "/";
console.log(location.pathname,'lllllllllaaaa')
  useEffect(() => {
    const checkUser = async () => {
      const currentSession = await session;
      if (currentSession?.user) {
        setUser(currentSession.user);
      } else {
        setUser(null);
      }
    };

    checkUser();

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') {
        setUser(null);
        navigate('/login');
      } else if (event === 'SIGNED_IN') {
        setUser(session?.user);
      }
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [session, navigate]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'الرئيسية', href: '/' },
    // { name: 'خدماتنا', href: '/'},
    // { name: 'عن الشركة', href: '/'},
    // { name: 'فريق العمل ', href: '/'},
    // { name: 'آراء العملاء', href: '#testimonials' },
    // { name: 'اتصل بنا', href: '/'},
    // { name: 'المدونة', href: '/'}
  ];

  const scrollToSection = (sectionId) => {
    const section = document.querySelector(sectionId);
    if (section) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({ top: sectionTop, behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 right-0 left-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white  text-navy-900                shadow-md py-2' : 'bg-[#1e2a54]  py-2            text-white'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo and Title */}
          <div className="flex items-center whitespace-nowrap">
            <NRLogo color={isScrolled ? '#1e2a54' : '#FFFFFF'} />
            <span className={`mr-2 font-bold ${
              isScrolled ? 'text-navy-900' : 'text-white'
            } text-sm sm:text-base lg:text-lg`}>
              شركة الراجحي و المطيري للمحاماة
            </span>
          </div>

          {/* Desktop Navigation - Only on large screens (≥1024px) */}
          <nav className="hidden lg:flex items-center space-x-4 rtl:space-x-reverse whitespace-nowrap">
            {navItems.map((item) => (
              <a 
                key={item.name} 
                href={ item.href}
                // onClick={(e) => {
                //   if (item.href.startsWith('#')) {
                //     e.preventDefault();
                //     scrollToSection(item.href);
                //   } else{
                //     window.location.href = '/'
                //   }

                // }}

                className={`font-medium hover:text-navy-600 transition-colors duration-300 ${
                  isScrolled ? 'text-navy-900' : 'text-white'
                } text-sm lg:text-base`}
              >
                {item.name}
              </a>
            ))}

            {/* Authenticated User Buttons */}
            {user && (
              <>
                <a
                  href="/post"
                  className={`font-medium hover:text-navy-600 transition-colors duration-300 ${
                    isScrolled ? 'text-navy-900' : 'text-white'
                  } text-sm lg:text-base`}
                >
                  إنشاء منشور
                </a>
                <a
                  href="/emails"
                  className={`font-medium hover:text-navy-600 transition-colors duration-300 ${
                    isScrolled ? 'text-navy-900' : 'text-white'
                  } text-sm lg:text-base`}
                >
                  البريد الإلكتروني
                </a>
                <LogoutButton />
              </>
            )}
          </nav>

          {/* Mobile Menu Toggle */}
          <button 
            className="lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? 
              <X className={`h-6 w-6 ${isScrolled ? 'text-navy-900' : 'text-white'}`} /> : 
              <Menu className={`h-6 w-6 ${isScrolled ? 'text-navy-900' : 'text-white'}`} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 bg-white rounded-lg shadow-lg p-4 absolute left-4 right-4 top-16">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <a 
                  key={item.name} 
                  href={item.href}
                  onClick={(e) => {
                    if (item.href.startsWith('#')) {
                      e.preventDefault();
                      scrollToSection(item.href);
                    }
                  }}
                  className="text-navy-900 text-base font-medium block py-2 px-4 hover:bg-gray-100 rounded transition-colors duration-200 whitespace-nowrap"
                >
                  {item.name}
                </a>
              ))}

              {/* Mobile Auth Buttons */}
              {user && (
                <>
                  <a 
                    href="/post"
                    className="text-navy-900 text-base font-medium block py-2 px-4 hover:bg-gray-100 rounded transition-colors duration-200 whitespace-nowrap"
                  >
                    إنشاء منشور
                  </a>
                  <a 
                    href="/emails"
                    className="text-navy-900 text-base font-medium block py-2 px-4 hover:bg-gray-100 rounded transition-colors duration-200 whitespace-nowrap"
                  >
                    البريد الإلكتروني
                  </a>
                  <LogoutButton />
                </>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
